import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    profile: null,
    showNeedLogin: false
  }),
  getters: {},
  actions: {
    setProfile(profile) {
      this.profile = profile;
    },
    setTimeout(value) {
      this.profile.timeoutUntil = value;
    },
    setShowNeedLogin(show) {
      this.showNeedLogin = show;
    },
    async logout() {
      await useApi('/api/auth/logout', {
        method: 'POST',
      });
      this.setProfile(null);
      const router = useRouter();
      const localePath = useLocalePath();
      router.push(localePath({ name: 'index' }));
    },
    
    async updateProfile(updatedFields) {
      const { data, error } = await useApi('/api/users/update-profile', {
        method: 'PATCH',
        body: updatedFields,
      });
      
      if (!error) {
        this.profile = this.updateNestedObject(this.profile, updatedFields);
      }
      
      return { data, error };
    },
    updateNestedObject(original, updates) {
      const result = { ...original };
      
      Object.keys(updates).forEach(key => {
        if (typeof updates[key] === 'object' && updates[key] !== null && 
        typeof original[key] === 'object' && original[key] !== null) {
          result[key] = this.updateNestedObject(original[key], updates[key]);
        } else {
          result[key] = updates[key];
        }
      });
      
      return result;
}
  },
  // persist: {
  //   enabled: true, // Persist özelliğini etkinleştir
  //   storage: piniaPluginPersistedstate.sessionStorage(),
  //   debug: true,
  // },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
